<template>
  <div class="full-width">
    <v-flex xs12
      class="body-1 px-4 py-3 text-xs-left"
    >
      Before selecting your offer, please review the
      <span
        @click="openDocument(fortivaTermsSummary)"
        class="wf-link clickable"
        id="gtm.summary_terms"
      >
        Summary of Credit Terms
      </span>
      which summarizes the key terms of
      the Cardholder Agreement that will govern your Fortiva Retail
      Credit revolving account.  Next, select one of the offers below.
    </v-flex>
    <SelectOffer
      v-if="multipleOffers"
    />
    <SingleOffer
      v-else
    />
    <v-flex xs8 offset-xs2>
      <p class="grey--text text--darken-1 mb-1 caption">
        Upon accepting the offer, you will be emailed a copy of your Cardholder Agreement and a welcome message from Fortiva Customer Service.
      </p>
    </v-flex>
    <AppNextButton
      v-if="!sending"
      :buttonFunction="acceptAndFinish"
    >
      Accept Offer
    </AppNextButton>
    <AppNextButton
      v-else
    >
      Sending
    </AppNextButton>
    <StatusModal
      v-if="confirmationModal"
      :companyImage="fortiva2x"
      :mainButtonFunction="confirmTerms"
      :showModal="confirmationModal"
    >
      <div slot="main-text">
        Thank you for accepting the Fortiva Retail Credit offer.
        Please confirm receipt of the full terms and conditions governing
        your account as shown below.
      </div>
      <div slot="secondary-text"
        class="text-xs-left"
      >
        By clicking "AGREE", you agree that you have:<br/>
        (i) read and understood your
        <span
          @click="openDocument(fortivaCardholderAgreement)"
          class="wf-link"
        >
          Cardholder Agreement
        </span>,
        including any deferred interest offer, and agree to be bound by its
        terms<br/>
        (ii) provided the correct email address in order to retain a copy of
        the Cardholder Agreement for your records.
      </div>
      <div slot="tertiary-text"
        class="text-xs-left mt-3"
      >
        We have emailed a copy of the
        <span
          @click="openDocument(fortivaCardholderAgreement)"
          class="wf-link"
        >
          Cardholder Agreement
        </span>
        to {{ customerData.emailAddress }}.
      </div>
      <span slot="main-button-text">
        AGREE
      </span>
    </StatusModal>
    <StatusModal
      :companyImage="fortiva2x"
      :mainButtonFunction="returnHome"
      :showModal="congratsModal"
    >
      <div slot="main-text">
        <div class="title mb-2">Congratulations!</div>
        Your account with Fortiva Retail Credit is now available.
      </div>
      <span slot="main-button-text">
        OK
      </span>
    </StatusModal>
  </div>
</template>

<script>
  import AppNextButton from 'Components/AppNextButton.vue'
  import SelectOffer from 'Components/SelectOffer.vue'
  import SingleOffer from 'Components/SingleOffer.vue'
  import StatusModal from 'Components/StatusModal.vue'
  import { emailFormData } from 'Helpers/CreditApplicationFormHelper.js'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'FortivaResults',
    components: {
      AppNextButton,
      SelectOffer,
      SingleOffer,
      StatusModal
    },
    data () {
      return {
        cardholderAgreementLink: 'https://www.fortivafinancial.com/wp-content/uploads/2018/02/FCC-Generic-Cardholder-Agreement.pdf',
        changeEmail: false,
        confirmationModal: false,
        congratsModal: false,
        emailFormData,
        emailModal: false,
        fortiva2x: require('Assets/fortiva_logo@2x.png'),
        newEmail: '',
        sending: false
      }
    },
    computed: {
      ...mapState({
        lender: state => state.loanApplication.lender,
        customerData: state => state.loanApplication.customerData,
        loanOffers: state => state.loanApplication.loanOffers,
        fortivaTermsSummary: state => state.loanApplication.fortivaTermsSummary,
        fortivaCardholderAgreement: state => state.loanApplication.fortivaCardholderAgreement,
        easyLinkUser: state => state.easyLink.active,
      }),
      multipleOffers () {
        return this.loanOffers.length > 1
      } 
    },
    methods: {
      ...mapActions([
        'acceptOffer',
        'loanApplicationClear',
        'setCustomerData'
      ]),
      acceptAndFinish () {
        this.emailModal = false
        this.sending = true
        this.acceptOffer().then(success => {
          this.confirmationModal = true
          this.sending = false
        })
      },
      /*acceptWithNewEmail () {
        const loanData = {
          ...this.customerData,
          emailAddress: this.newEmail
        }
        this.setCustomerData(loanData)
        this.acceptAndFinish()
      },*/
      confirmTerms () {
        this.confirmationModal = false
        this.congratsModal = true
      },
      openDocument (base64String) {
        let pdfWindow = window.open('')
        setTimeout(() => {
          pdfWindow.document.write('<iframe width="100%" height="100%" src="data:application/pdf;base64, ' + base64String + '"></iframe>')
        }, 50)
      },
      returnHome () {
        this.loanApplicationClear()
        if (this.easyLinkUser) {
          this.$router.push({
            path: '/credit-application/application-done'
          })
        } else {
          this.$router.push({
            path: '/home'
          })
        }
      },
      showEmailModal () {
        this.emailModal = true
      },
      showEmailField () {
        this.changeEmail = !this.changeEmail
      }
    }
  }
</script>

<style scoped lang="scss">
  .email-modal-button {
    width: 30%;
    max-width: 200px;
  }

  .clickable {
    cursor: pointer;
  }

  .lender-tile >>> .subheading{
    font-size: 1em!important;
  }
</style>
